import React from 'react';
import { SerializedStyles, css } from '@emotion/react';
import { useTheme } from '@veneer/theme';
import getPillBorder from '../utils/get_pill_border';

const useStyles = ({
  horizontal,
  vertical,
}: {
  horizontal: string;
  vertical: string;
}): {
  root: SerializedStyles;
  badge: SerializedStyles;
  count: {
    base: SerializedStyles;
    hc: SerializedStyles;
    floating: SerializedStyles;
  };
} => {
  const theme = useTheme();

  return React.useMemo(
    () => ({
      root: css({
        display: 'inline-flex',
        position: 'relative',
      }),
      badge: css({
        backgroundColor: theme.color.negative.base.default,
        borderColor: theme.color.background.default,
        borderRadius: '50%',
        borderStyle: 'solid',
        borderWidth: 1,
        boxSizing: 'border-box',
        display: 'flex',
        height: `calc(${theme.layout.size2} + 2px)`,
        minWidth: `calc(${theme.layout.size2} + 2px)`,
        position: 'absolute',
        zIndex: 1,
        [horizontal]: 0,
        [vertical]: 0,
      }),
      count: {
        base: css({
          ...theme.typography.labelSmall,
          backgroundColor: theme.color.background.container.default,
          border: `1px solid ${theme.color.stroke.decorative.default}`,
          borderRadius: getPillBorder,
          color: theme.color.foreground.default,
          maxBlockSize: 'fit-content',
          minWidth: `calc(${theme.layout.size4} + 2px)`,
          padding: `0 ${theme.layout.size1}`,
          textAlign: 'center',
        }),
        hc: css({
          border: `1px solid ${theme.color.foreground.default}`,
        }),
        floating: css({
          position: 'absolute',
          zIndex: 1,
          [horizontal]: 0,
          [vertical]: 0,
        }),
      },
    }),
    [horizontal, theme, vertical]
  );
};

export default useStyles;
